import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {A11yModule} from '@angular/cdk/a11y';
import {BidiModule} from '@angular/cdk/bidi';
import {ObserversModule} from '@angular/cdk/observers';
import {OverlayModule} from '@angular/cdk/overlay';
import {PlatformModule} from '@angular/cdk/platform';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';

import {MatToolbarModule} from '@angular/material/toolbar';
import {
  MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule,MatButtonModule,MatButtonToggleModule,MatCardModule, MatTabsModule, 
  MatCheckboxModule,MatChipsModule,MatDatepickerModule,MatDialogModule,MatDividerModule,MatExpansionModule, MatFormFieldModule, 
  MatSelectModule , MatGridListModule,  MatIconModule,  MatInputModule,  MatListModule,  MatMenuModule,  
  MatNativeDateModule,  MatPaginatorModule,  MatProgressBarModule,  MatProgressSpinnerModule, MatRadioModule, 
  MatRippleModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule,MatSnackBarModule, MatSortModule, 
  MatStepperModule,  MatTooltipModule, MatTableModule, MatTreeModule,
} from '@angular/material';
import { MomentModule } from 'ngx-moment';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './login';
import { AuditComponentComponent } from './components/auditTrail/audit-component/audit-component.component';
import { AuditTrailComponent } from './components/auditTrail/audit-trail/audit-trail.component';
import { AuditEventsComponent } from './components/auditTrail/audit-events/audit-events.component';
import { DisplaySearchCriteriasComponent } from './components/display-search-criterias/display-search-criterias.component';
import { AuditCompComponent } from './components/auditTrail/audit-comp/audit-comp.component';
import { CdkDetailRowDirective } from './directives/cdk-detail-row.directive';
import { DoubleRowPaginatorComponent } from './components/double-row-paginator/double-row-paginator.component';
import { HttpInterceptorService } from './http-interceptor.service';
import { AuditGetSessionComponent } from './components/audit-get-session/audit-get-session.component';


/**
 * NgModule that includes all Material modules that are required to serve the app.
 */
@NgModule({
  exports: [
    // CDK
    A11yModule,
    BidiModule,
    ObserversModule,
    OverlayModule,
    PlatformModule,
    PortalModule,
    ScrollDispatchModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    
    // Material
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
  ],
  declarations: []
})
export class MaterialModule {}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    SearchPanelComponent,
    AuditComponentComponent,
    AuditTrailComponent,
    AuditEventsComponent,
    DisplaySearchCriteriasComponent,
    AuditCompComponent,
    CdkDetailRowDirective, DoubleRowPaginatorComponent, AuditGetSessionComponent
  ],
  imports: [
    FormsModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MomentModule,
    MaterialModule, AppRoutingModule, NgbModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
